<div class="chart-container">
  <div class="chart-card" *ngFor="let chartOption of chartOptionsList; let i = index"
    [ngClass]="chartOption.widthClass">
    <div class="chart-header">
      <div class="chart-title">{{ chartOption.options.title?.text }}</div>
    </div>
    <p class="title-border"></p>
    <div class="chart-subtitle-wrapper">
      <div class="chart-subtitle">{{ chartOption.options.subtitle?.text }}</div>
    </div>
    <highcharts-chart id="chart-container-{{ i }}" (chartInstance)="onChartInstance($event, i)"
      [Highcharts]="Highcharts" class="chart-list" [options]="chartOption.options">
    </highcharts-chart>
  </div>
</div>